import { Skeleton, Tooltip } from "antd";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";

const CodesTable = ({ data, loading }) => {
  const transformedData = !loading
    ? Object.entries(data || {}).map(([bankName, areaCodeArray], index) => ({
        key: index,
        bank_name: bankName,
        area_codes: areaCodeArray.map((item) => ({
          areacode: item.area_code,
          status: item.status,
        })),
      }))
    : [];

  const columns = [
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name",
      render: (bankName) =>
        loading ? <Skeleton.Input size="small" active /> : bankName ?? "N/A",
    },
 {
  title: "Pin Codes",
  dataIndex: "area_codes",
  key: "area_codes",
  render: (area_codes) => {
    if (loading) {
      return <Skeleton.Input size="small" active />;
    }

    const codes = area_codes?.map((item) => item?.areacode).filter(Boolean) || [];

    if (codes.length <= 3) {
      return <span>{codes.join(", ") || "N/A"}</span>;
    }

    const visibleCodes = codes.slice(0, 3).join(", ");
    const hiddenCodes = codes.slice(3).join(", ");

    return (
      <span>
        {visibleCodes},{" "}
        <Tooltip title={hiddenCodes}>
          <span style={{ color: "#abababff", cursor: "pointer" }}>+{codes.length - 3} more</span>
        </Tooltip>
      </span>
    );
  },
}

  ];

  return (
    <div
      className="codes_table_container"
      style={{ width: "100%", height: "100%" }}
    >
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(4).fill(0) : transformedData}
        rowKey="key"
        bordered
        pageSize={10}
        CurrentPageNo={1}
        totalItems={transformedData?.length}
      />
    </div>
  );
};

export default CodesTable;
